import { Suspense } from 'react';
import { Layout } from 'antd';
import SiteHeader from '../components/customization/header';
import Can from '../services/permisions/Can';

const { Content } = Layout;

/* Main Layout */
const UICustomizationLayout = ({ children, ...rest }) => {
  return (
    <Layout>
      <Layout>
        <SiteHeader></SiteHeader>
        <Layout>
          <Content>
            {children}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  )
}

/*
  Private route wrapper
 */

export const UICustomizationLayoutRoute = ({ component: Component, permissions, ...rest }) => {
  return (
    <Can I={permissions.type} a={permissions.name} withRedirect={true} >
      <UICustomizationLayout>
        <Suspense fallback={<></>}>
          <Component {...rest} />
        </Suspense>
      </UICustomizationLayout>
    </Can>
  );
};

